import { ArticlePoll } from 'www/modules/article-poll'
import { FastFiveNavigation } from './modules/fast-five/pagination';
import { PromosToolbar } from './modules/common/toolbar/promos-toolbar';
import { GlobalSvgSprites } from 'www/svg-icons/lib/global-svg-sprites';
import { Medscape } from 'www/medscape';
import { Ads } from './modules/fast-five/ads';
import { cpArticleLoad } from 'www/modules/cp/cp-article-load';

Medscape.ArticlePage.type = "FAST_FIVE";
let { webmd } = window;

export default class FastFiveArticle {
    constructor(el) {
        this.el = el;
        this.el.classList.add('fast-five-article');
        this.paginationNav = null;
		if (typeof mscpA2A == 'undefined' || !mscpA2A) {
			window.hideModal = function () { };
		}
    }
    init() {
        this.initSvgSprites();
        this.initNavigation();
        ArticlePoll.init(this.el);
        if (typeof mscpA2A == 'undefined' || !mscpA2A) Ads.init();
        cpArticleLoad('viewarticle');
        window.addEventListener('message', (event) => {
            // Add event listener for message
            if (event.data && typeof event.data == "string" && event.data.indexOf('loadSponsoredPoll') >= 0) {
                if (Medscape.ArticlePage && Medscape.ArticlePage.createSponsoredPoll) {
                    const config = JSON.parse(event.data);
                    if (config['payload']) {
                        Medscape.ArticlePage.createSponsoredPoll(config['payload']);
                    }
                }
            }
        });
    }

    initSvgSprites() {
        document.body.appendChild(GlobalSvgSprites.el);
    }
    initNavigation() {
        let paginationContainer = this.el.querySelector('#pagination');
        this.paginationNav = new FastFiveNavigation(paginationContainer);
        this.paginationNav.init();
    }
}

if (typeof mscpA2A == 'undefined' || !mscpA2A) {
	let fastFiveArticle = new FastFiveArticle(document.getElementById('bodypadding'));
	fastFiveArticle.init();
}

window.fastFiveInit = function(el) {
	let defaultArtType = Medscape.ArticlePage.type;
	Medscape.ArticlePage.type = "FAST_FIVE";
    let fastFiveInst = new FastFiveArticle(el);
    fastFiveInst.init();
	Medscape.ArticlePage.type = defaultArtType;
}
